import { useEffect } from "react";

export const useOnClickOutside = (ref, handler) => {
  //do we click outside element (another ref) ?
  //element that is referenced to to check if we are outside need a ref! see burgermenu
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};
